import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import ReactMarkdown from 'react-markdown';
import * as XLSX from 'xlsx';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Tooltip } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets/illustrations';
//
import Iconify from '../iconify';
//
import RejectionFiles from './errors-rejection-files';
import MultiFilePreview from './preview-multi-file';
import SingleFilePreview from './preview-single-file';
import test from './test.json'
import ClickableTooltip from '../tooltip/clickable-tooltip';

// ----------------------------------------------------------------------
export function getTransactionData() {

    const rawData = localStorage.getItem('transactionsData');
      if (!rawData) return null;

    const json = JSON.parse(rawData)

    const data = json.map((_, i) => ({
      value_date: json[i].value_date,
      amount: json[i].amount,
      balance: json[i].balance,
      concepts: json[i].concepts,
      transaction_id: json[i].transaction_id
    }))

    console.log(data)
    return data
}

export function getFinancialData() {
    const rawData = localStorage.getItem('financeData');
    if (!rawData) return null;
    const json = JSON.parse(rawData).json;
    const status = JSON.parse(rawData).status;

    // const rawData = localStorage.getItem('financeData');
    // // if (!rawData) return null;
    // let json
    // let status
    // if (rawData) {
    //   json = JSON.parse(rawData).json;
    //   status = JSON.parse(rawData).status;
    // } else {
    //   json = test.json;
    //   status = test.status;
    // }

    if (status === "failed_quality_check") {
      return {
        esValido: json.agb.valido,
        validoMessage: json.agb.message,
        alertas: {
          dias_sin_transacciones: json.dias_sin_transacciones,
          dias_profundidad_agregacion: json.dias_profundidad_agregacion,
          n_transacciones_total: json.n_transacciones_total,
          num_cuentas: json.num_cuentas_agb,
        }
      }
    }

    const categorizado = json.transaccional_categorizado.map((_, i) => ({
      amount: json.transaccional_categorizado[i].amount || 0,
      aux_detalle_export: json.transaccional_categorizado[i].aux_detalle_export || '',
      concepts: json.transaccional_categorizado[i].concepts || '',
      balance_final: json.transaccional_categorizado[i].balance_final || 0,
      value_date: json.transaccional_categorizado[i].value_date || '',
      metodo: json.transaccional_categorizado[i].metodo || '',
      agrupacion: json.transaccional_categorizado[i].agrupacion || '',
      categoria: json.transaccional_categorizado[i].CATEGORIA || '',
      detalle: json.transaccional_categorizado[i].DETALLE || '',
    }))

    const metodos_categorizacion = {
      abono: {
        llm: json.metodos_categorizacion.abono.llm || 0,
        tags: json.metodos_categorizacion.abono.tags || 0,
      },
      egreso: {
        llm: json.metodos_categorizacion.egreso.llm || 0,
        tags: json.metodos_categorizacion.egreso.tags || 0,
      },
      global: {
        llm: json.metodos_categorizacion.global.llm || 0,
        tags: json.metodos_categorizacion.global.tags || 0,
      }
    }

    const abonoHistoricos = json.fecha.map((_, i) => ({
      date: json.fecha[i],
      abono: json.abono.historico.year_month.total_abono[i] || 0,
      abono_duro: json.abono.historico.year_month.total_abono_duro[i] || 0,
      abono_blando: json.abono.historico.year_month.total_abono_blando[i] || 0,
      abono_movimientos: json.abono.historico.year_month.total_abono_efectivoytransfer[i] || 0,
      abono_resto: json.abono.historico.year_month.total_abono_otros[i] || 0,
      abono_trabajo: json.abono.historico.year_month.total_abono_trabajo[i] || 0,
      abono_pension: json.abono.historico.year_month.total_abono_pension[i] || 0,
      abono_subsidio: json.abono.historico.year_month.total_abono_subsidio[i] || 0,
      abono_facturacion: json.abono.historico.year_month.total_abono_facturacion[i] || 0,
      abono_ahorro: json.abono.historico.year_month.total_abono_ahorro[i] || 0,
      abono_ahorro_duro: json.abono.historico.year_month.total_abono_ahorro_duro[i] || 0,
      abono_financiacion: json.abono.historico.year_month.total_abono_financiacion[i] || 0,
      abono_devolucion: json.abono.historico.year_month.total_abono_devolucion[i] || 0,
      abono_anulacion: json.abono.historico.year_month.total_abono_anulacion[i] || 0,
      abono_gambling: json.abono.historico.year_month.total_abono_gambling[i] || 0,
      abono_gambling_blando: json.abono.historico.year_month.total_abono_gambling_blando[i] || 0,
      abono_impuestos: json.abono.historico.year_month.total_abono_impuestos[i] || 0,
      abono_efectivo: json.abono.historico.year_month.total_abono_efectivo[i] || 0,
      abono_transferencias: json.abono.historico.year_month.total_abono_transferencias[i] || 0,
      abono_traspaso_entrecuentas: json.abono.historico.year_month.total_abono_traspaso_entrecuentas[i] || 0,
      abono_traspaso: json.abono.historico.year_month.total_abono_traspaso_efectivo_transfer[i] || 0,
      abono_extraordinarios: json.abono.historico.year_month.total_abono_resto[i] || 0,
    }))

    const abonoResumen = {
      abono: json.abono.prom_abono || 0,
      abono_duro: json.abono.prom_abono_duro || 0,
      abono_blando: json.abono.prom_abono_blando || 0,
      abono_movimientos: json.abono.prom_abono_efectivoytransfer || 0,
      abono_resto: json.abono.prom_abono_otros || 0,
      abono_trabajo: json.abono.prom_abono_trabajo || 0,
      abono_pension: json.abono.prom_abono_pension || 0,
      abono_subsidio: json.abono.prom_abono_subsidio || 0,
      abono_facturacion: json.abono.prom_abono_facturacion || 0,
      abono_ahorro: json.abono.prom_abono_ahorro || 0,
      abono_financiaciones: json.abono.prom_abono_financiaciones || 0,
      abono_devolucion: json.abono.prom_abono_devolucion || 0,
      abono_anulacion: json.abono.prom_abono_anulacion || 0,
      abono_gambling: json.abono.prom_abono_gambling || 0,
      abono_impuestos: json.abono.prom_abono_impuestos || 0,
      abono_efectivo: json.abono.prom_abono_efectivo || 0,
      abono_transferencias: json.abono.prom_abono_transferencias || 0,
      abono_traspaso_entrecuentas: json.abono.prom_abono_traspaso_entrecuentas || 0,
      monto_semestral_abono: json.abono.monto_semestral_abono || 0,
      monto_semestral_abono_ahorro: json.abono.monto_semestral_abono_ahorro || 0,
      monto_semestral_abono_anulacion: json.abono.monto_semestral_abono_anulacion || 0,
      monto_semestral_abono_blando: json.abono.monto_semestral_abono_blando || 0,
      monto_semestral_abono_devolucion: json.abono.monto_semestral_abono_devolucion || 0,
      monto_semestral_abono_duro: json.abono.monto_semestral_abono_duro || 0,
      monto_semestral_abono_efectivo: json.abono.monto_semestral_abono_efectivo || 0,
      monto_semestral_abono_movimientos: json.abono.monto_semestral_abono_efectivoytransfer || 0,
      monto_semestral_abono_facturacion: json.abono.monto_semestral_abono_facturacion || 0,
      monto_semestral_abono_financiaciones: json.abono.monto_semestral_abono_financiaciones || 0,
      monto_semestral_abono_gambling: json.abono.monto_semestral_abono_gambling || 0,
      monto_semestral_abono_impuestos: json.abono.monto_semestral_abono_impuestos || 0,
      monto_semestral_abono_resto: json.abono.monto_semestral_abono_otros || 0,
      monto_semestral_abono_pension: json.abono.monto_semestral_abono_pension || 0,
      monto_semestral_abono_subsidio: json.abono.monto_semestral_abono_subsidio || 0,
      monto_semestral_abono_trabajo: json.abono.monto_semestral_abono_trabajo || 0,
      monto_semestral_abono_transferencias: json.abono.monto_semestral_abono_transferencias || 0,
      monto_semestral_abono_traspaso_entrecuentas: json.abono.monto_semestral_abono_traspaso_entrecuentas || 0,
      porc_abono_ahorro: json.abono.porc_abono_ahorro || 0,
      porc_abono_anulacion: json.abono.porc_abono_anulacion || 0,
      porc_abono_blando: json.abono.porc_abono_blando || 0,
      porc_abono_devolucion: json.abono.porc_abono_devolucion || 0,
      porc_abono_duro: json.abono.porc_abono_duro || 0,
      porc_abono_efectivo: json.abono.porc_abono_efectivo || 0,
      porc_abono_movimientos: json.abono.porc_abono_efectivoytransfer || 0,
      porc_abono_facturacion: json.abono.porc_abono_facturacion || 0,
      porc_abono_financiaciones: json.abono.porc_abono_financiaciones || 0,
      porc_abono_gambling: json.abono.porc_abono_gambling || 0,
      porc_abono_impuestos: json.abono.porc_abono_impuestos || 0,
      porc_abono_resto: json.abono.porc_abono_otros || 0,
      porc_abono_pension: json.abono.porc_abono_pension || 0,
      porc_abono_subsidio: json.abono.porc_abono_subsidio || 0,
      porc_abono_trabajo: json.abono.porc_abono_trabajo || 0,
      porc_abono_transferencias: json.abono.porc_abono_transferencias || 0,
      porc_abono_traspaso_entrecuentas: json.abono.porc_abono_traspaso_entrecuentas || 0,
      estabilidad_abono: json.abono.estabilidad_abono || 0,
      porcentaje_categor_abono: json.abono.porcentaje_categor_abono || 0,
      historico: abonoHistoricos,
    }

    const gastoHistoricos = json.fecha.map((_, i) => ({
      date: json.fecha[i],
      gasto: json.gasto.historico.year_month.total_gasto[i] || 0,
      gasto_basico: json.gasto.historico.year_month.total_gasto_basico[i] || 0,
      gasto_discrecional: json.gasto.historico.year_month.total_gasto_discrecional[i] || 0,
      gasto_traspaso: json.gasto.historico.year_month.total_gasto_efectivo_transfer_traspaso[i] || 0,
      gasto_movimientos: json.gasto.historico.year_month.total_gasto_efectivoytransfer[i] || 0,
      gasto_resto: json.gasto.historico.year_month.total_gasto_otros[i] || 0,
      gasto_consumo_basico: json.gasto.historico.year_month.total_gasto_consumo_indispensable[i] || 0,
      gasto_consumo_discrecional: json.gasto.historico.year_month.total_gasto_consumo_variado[i] || 0,
      gasto_recibo: json.gasto.historico.year_month.total_gasto_recibos[i] || 0,
      gasto_impuestos: json.gasto.historico.year_month.total_gasto_impuestos[i] || 0,
      gasto_ahorro: json.gasto.historico.year_month.total_gasto_ahorro[i] || 0,
      gasto_financiacion: json.gasto.historico.year_month.total_gasto_financiacion[i] || 0,
      gasto_tarjetadecredito: json.gasto.historico.year_month.total_gasto_tarjetadecredito[i] || 0,
      gasto_comisiones: json.gasto.historico.year_month.total_gasto_comisiones[i] || 0,
      gasto_tpv: json.gasto.historico.year_month.total_gasto_comisiones_gastos_tpv[i] || 0,
      gasto_gambling: json.gasto.historico.year_month.total_gasto_gambling[i] || 0,
      gasto_recobro: json.gasto.historico.year_month.total_gasto_recobro[i] || 0,
      gasto_embargo: json.gasto.historico.year_month.total_gasto_embargo[i] || 0,
      gasto_efectivo: json.gasto.historico.year_month.total_gasto_efectivo[i] || 0,
      gasto_transferencias: json.gasto.historico.year_month.total_gasto_transferencias[i] || 0,
      gasto_traspaso_entrecuentas: json.gasto.historico.year_month.total_gasto_traspaso_entrecuentas[i] || 0,
      gasto_extraordinarios: json.gasto.historico.year_month.total_gasto_resto[i] || 0,
    }))

    const gastoResumen = {
      gasto: json.gasto.prom_gasto || 0,
      estabilidad_gasto_basico_tot_gasto: json.gasto.estabilidad_gasto_basico_tot_gasto || 0,
      estabilidad_gasto_basico_tot_ingreso: json.gasto.estabilidad_gasto_basico_tot_ingreso || 0,
      estabilidad_gasto_discrecional_tot_gasto: json.gasto.estabilidad_gasto_discrecional_tot_gasto || 0,
      estabilidad_gasto_discrecional_tot_ingreso: json.gasto.estabilidad_gasto_discrecional_tot_ingreso || 0,
      estabilidad_gasto_movimientos_tot_gasto: json.gasto.estabilidad_gasto_efectivoytransfer_tot_gasto || 0,
      estabilidad_gasto_movimientos_tot_ingreso: json.gasto.estabilidad_gasto_efectivoytransfer_tot_ingreso || 0,
      gasto_ahorro: json.gasto.prom_gasto_ahorro || 0,
      gasto_alquiler: json.gasto.prom_gasto_alquiler || 0,
      gasto_art_electronicos: json.gasto.prom_gasto_art_electronicos || 0,
      gasto_basico: json.gasto.prom_gasto_basico || 0,
      gasto_belleza: json.gasto.prom_gasto_belleza || 0,
      gasto_comercioyga: json.gasto.prom_gasto_comercioyga || 0,
      gasto_comisiones: json.gasto.prom_gasto_comisiones || 0,
      gasto_consumo_basico: json.gasto.prom_gasto_consumo_basico || 0,
      gasto_consumo_discrecional: json.gasto.prom_gasto_consumo_discrecional || 0,
      gasto_cultura: json.gasto.prom_gasto_cultura || 0,
      gasto_deporte: json.gasto.prom_gasto_deporte || 0,
      gasto_discrecional: json.gasto.prom_gasto_discrecional || 0,
      gasto_ecommerce: json.gasto.prom_gasto_ecommerce || 0,
      gasto_educacion: json.gasto.prom_gasto_educacion || 0,
      gasto_efectivo: json.gasto.prom_gasto_efectivo || 0,
      gasto_movimientos: json.gasto.prom_gasto_efectivoytransfer || 0,
      gasto_embargo: json.gasto.prom_gasto_embargo || 0,
      gasto_ffood: json.gasto.prom_gasto_ffood || 0,
      gasto_financiacion: json.gasto.prom_gasto_financiacion || 0,
      gasto_gambling: json.gasto.prom_gasto_gambling || 0,
      gasto_gasolina: json.gasto.prom_gasto_gasolina || 0,
      gasto_hogar: json.gasto.prom_gasto_hogar || 0,
      gasto_impuestos: json.gasto.prom_gasto_impuestos || 0,
      gasto_mascota: json.gasto.prom_gasto_mascota || 0,
      gasto_microprestamos: json.gasto.prom_gasto_microprestamos || 0,
      gasto_multas: json.gasto.prom_gasto_multas || 0,
      gasto_nomina: json.gasto.prom_gasto_nomina || 0,
      gasto_obligaciones: json.gasto.prom_gasto_obligaciones || 0,
      gasto_ocio: json.gasto.prom_gasto_ocio || 0,
      gasto_ongs: json.gasto.prom_gasto_ongs || 0,
      gasto_resto: json.gasto.prom_gasto_otros || 0,
      gasto_recibo: json.gasto.prom_gasto_recibo || 0,
      gasto_recobro: json.gasto.prom_gasto_recobro || 0,
      gasto_restaurantes: json.gasto.prom_gasto_restaurantes || 0,
      gasto_ropa: json.gasto.prom_gasto_ropa || 0,
      gasto_supermercado: json.gasto.prom_gasto_supermercado || 0,
      gasto_suscripcionesgaming: json.gasto.prom_gasto_suscripcionesgaming || 0,
      gasto_tarjetadecredito: json.gasto.prom_gasto_tarjetadecredito || 0,
      gasto_tprivado: json.gasto.prom_gasto_tprivado || 0,
      gasto_tpublico: json.gasto.prom_gasto_tpublico || 0,
      gasto_transferencias: json.gasto.prom_gasto_transferencias || 0,
      gasto_traspaso: json.gasto.prom_gasto_traspaso || 0,
      gasto_traspaso_entrecuentas: json.gasto.prom_gasto_traspaso_entrecuentas || 0,
      gasto_viajes: json.gasto.prom_gasto_viajes || 0,
      porc_gasto_basico: json.gasto.porc_gasto_basico || 0,
      porc_gasto_discrecional: json.gasto.porc_gasto_discrecional || 0,
      porc_gasto_traspaso: json.gasto.porc_gasto_traspaso || 0,
      porc_gasto_movimientos: json.gasto.porc_gasto_efectivoytransfer || 0,
      porc_gasto_financiacion: json.gasto.porc_gasto_financiacion || 0,
      porc_gasto_ahorro: json.gasto.porc_gasto_ahorro || 0,
      porc_gasto_alquiler: json.gasto.porc_gasto_alquiler || 0,
      porc_gasto_hogar: json.gasto.porc_gasto_hogar || 0,
      porc_gasto_tpublico: json.gasto.porc_gasto_tpublico || 0,
      porc_gasto_tprivado: json.gasto.porc_gasto_tprivado || 0,
      porc_gasto_gasolina: json.gasto.porc_gasto_gasolina || 0,
      porc_gasto_salud: json.gasto.porc_gasto_salud || 0,
      porc_gasto_supermercado: json.gasto.porc_gasto_supermercado || 0,
      porc_gasto_colegio: json.gasto.porc_gasto_colegio || 0,
      porc_gasto_mascota: json.gasto.porc_gasto_mascota || 0,
      porc_gasto_educacion: json.gasto.porc_gasto_educacion || 0,
      porc_gasto_restaurantes: json.gasto.porc_gasto_restaurantes || 0,
      porc_gasto_ffood: json.gasto.porc_gasto_ffood || 0,
      porc_gasto_ocio: json.gasto.porc_gasto_ocio || 0,
      porc_gasto_suscripcionesgaming: json.gasto.porc_gasto_suscripcionesgaming || 0,
      porc_gasto_cultura: json.gasto.porc_gasto_cultura || 0,
      porc_gasto_ropa: json.gasto.porc_gasto_ropa || 0,
      porc_gasto_deporte: json.gasto.porc_gasto_deporte || 0,
      porc_gasto_belleza: json.gasto.porc_gasto_belleza || 0,
      porc_gasto_viajes: json.gasto.porc_gasto_viajes || 0,
      porc_gasto_ongs: json.gasto.porc_gasto_ongs || 0,
      porc_gasto_comercioyga: json.gasto.porc_gasto_comercioyga || 0,
      porc_gasto_ecommerce: json.gasto.porc_gasto_ecommerce || 0,
      porc_gasto_recibo: json.gasto.porc_gasto_recibo || 0,
      porc_gasto_gambling: json.gasto.porc_gasto_gambling || 0,
      estabilidad_gasto: json.gasto.estabilidad_gasto_basico || 0,
      porcentaje_categor_gasto: json.gasto.porcentaje_categor_gasto || 0,
      monto_semestral_gasto_ahorro: json.gasto.monto_semestral_gasto_ahorro || 0,
      monto_semestral_gasto_microprestamos: json.gasto.monto_semestral_gasto_microprestamos || 0,
      monto_semestral_gasto_gambling: json.gasto.monto_semestral_gasto_gambling || 0,
      monto_semestral_gasto_multas: json.gasto.monto_semestral_gasto_multas || 0,
      monto_semestral_gasto_financiacion: json.gasto.monto_semestral_gasto_financiacion || 0,
      monto_semestral_gasto_alquiler: json.gasto.monto_semestral_gasto_alquiler || 0,
      monto_semestral_gasto_basico: json.gasto.monto_semestral_gasto_basico || 0,
      monto_semestral_gasto_belleza: json.gasto.monto_semestral_gasto_belleza || 0,
      monto_semestral_gasto_colegio: json.gasto.monto_semestral_gasto_colegio || 0,
      monto_semestral_gasto_comercioyga: json.gasto.monto_semestral_gasto_comercioyga || 0,
      monto_semestral_gasto_cultura: json.gasto.monto_semestral_gasto_cultura || 0,
      monto_semestral_gasto_deporte: json.gasto.monto_semestral_gasto_deporte || 0,
      monto_semestral_gasto_discrecional: json.gasto.monto_semestral_gasto_discrecional || 0,
      monto_semestral_gasto_ecommerce: json.gasto.monto_semestral_gasto_ecommerce || 0,
      monto_semestral_gasto_educacion: json.gasto.monto_semestral_gasto_educacion || 0,
      monto_semestral_gasto_ffood: json.gasto.monto_semestral_gasto_ffood || 0,
      monto_semestral_gasto_gasolina: json.gasto.monto_semestral_gasto_gasolina || 0,
      monto_semestral_gasto_hogar: json.gasto.monto_semestral_gasto_hogar || 0,
      monto_semestral_gasto_mascota: json.gasto.monto_semestral_gasto_mascota || 0,
      monto_semestral_gasto_ocio: json.gasto.monto_semestral_gasto_ocio || 0,
      monto_semestral_gasto_ongs: json.gasto.monto_semestral_gasto_ongs || 0,
      monto_semestral_gasto_recibo: json.gasto.monto_semestral_gasto_recibo || 0,
      monto_semestral_gasto_restaurantes: json.gasto.monto_semestral_gasto_restaurantes || 0,
      monto_semestral_gasto_ropa: json.gasto.monto_semestral_gasto_ropa || 0,
      monto_semestral_gasto_salud: json.gasto.monto_semestral_gasto_salud || 0,
      monto_semestral_gasto_supermercado: json.gasto.monto_semestral_gasto_supermercado || 0,
      monto_semestral_gasto_suscripcionesgaming: json.gasto.monto_semestral_gasto_suscripcionesgaming || 0,
      monto_semestral_gasto_tprivado: json.gasto.monto_semestral_gasto_tprivado || 0,
      monto_semestral_gasto_tpublico: json.gasto.monto_semestral_gasto_tpublico || 0,
      monto_semestral_gasto_viajes: json.gasto.monto_semestral_gasto_viajes || 0,
      total_numero_retiradas_efectivo: json.gasto.total_numero_retiradas_efectivo || 0,
      ticket_promedio_ffood: json.ticket_promedio_ffood || 0,
      ticket_promedio_restaurantes: json.ticket_promedio_restaurantes || 0,
      historico: gastoHistoricos,
    }

    const saldoResumen = {
      saldo_total_actual: json.saldo.saldo_actual || 0,
      saldo_maximo_reconstruido: json.saldo.saldo_maximo || 0,
      saldo_minimo_reconstruido: json.saldo.saldo_minimo || 0,
      porc_saldo_warning0: json.saldo.prop_saldo_min_diario_warning0 || 0,
      porc_saldo_warning100: json.saldo.prop_saldo_min_diario_warning100 || 0,
      porc_saldo_warning10: json.saldo.prop_saldo_min_diario_warning10 || 0,
      saldo_inicial: json.saldo.saldo_inicial.year_month || 0,
      saldo_final: json.saldo.saldo_final.year_month || 0,
      saldo_promedio: json.saldo.saldo_promedio|| 0,
      saldo_diario: json.saldo.historico_diario_grafico || [],
    }

    const alertasResumen = {
      monto_microprestamo: json.alertas.monto_microprestamo,
      monto_descubiertos: json.alertas.monto_descubiertos,
      monto_embargos: json.alertas.monto_embargos,
      monto_hijos: json.alertas.monto_hijos,
      monto_mascota: json.alertas.monto_mascota,
      monto_nomina: json.alertas.monto_nomina,
      monto_prestamo_constituido_mes: json.alertas.monto_prestamo_constituido_mes,
      monto_recibo_telecom_devuelto_mes: json.alertas.monto_recibo_telecom_devuelto_mes,
      monto_recibo_utilities_devuelto_mes: json.alertas.monto_recibo_utilities_devuelto_mes,
      monto_devolucion_recibos: json.alertas.monto_devolucion_recibos,
      monto_recobro: json.alertas.monto_recobro,
      monto_subsidio: json.alertas.monto_subsidio,
      monto_multa: json.alertas.monto_multa,
      monto_seguro_coche: json.alertas.monto_seguro_coche,
      monto_seguro_hogar: json.alertas.monto_seguro_hogar,
      monto_seguro_vida: json.alertas.monto_seguro_vida,
      monto_gambling: json.alertas.monto_gambling,
      monto_financiacion: json.alertas.monto_financiacion,
      promedio_seguro_coche: json.alertas.promedio_seguro_coche,
      promedio_seguro_hogar: json.alertas.promedio_seguro_hogar, 
      promedio_seguro_vida: json.alertas.promedio_seguro_vida,
      tiene_nomina: json.alertas.tiene_nomina,
      perdida_nomina: json.alertas.perdida_nomina,
      tiene_microprestamo: json.alertas.tiene_microprestamo,
      tiene_subsidio: json.alertas.tiene_subsidio,
      tiene_recibo_telecom_devuelto_mes: json.alertas.tiene_recibo_telecom_devuelto_mes,
      tiene_recibo_utilities_devuelto_mes: json.alertas.tiene_recibo_utilities_devuelto_mes,
      tiene_prestamo_constituido_mes: json.alertas.tiene_prestamo_constituido_mes,
      tiene_recobro: json.alertas.tiene_recobro,
      tiene_embargo: json.alertas.tiene_embargos,
      tiene_descubierto: json.alertas.tiene_descubierto, 
      tiene_devolucion_recibo: json.alertas.tiene_devolucion_recibos,
      tiene_gambling: json.alertas.tiene_gambling,
      tiene_multa : json.alertas.tiene_multa,
      tiene_financiacion: json.alertas.tiene_financiacion,
      tiene_alto_endeudamiento: json.alertas.tiene_alto_endeudamiento,
      porc_tasa_endeudamiento: json.alertas.porc_tasa_endeudamiento,
      regimen_vivienda: json.alertas.regimen_vivienda,
      regimen_contrato: json.alertas.regimen_contrato,
      es_empleado_reciente: json.alertas.es_empleado_reciente,
      es_funcionario: json.alertas.es_funcionario,
      tiene_mascota: json.alertas.tiene_mascota,
      tiene_hijos: json.alertas.tiene_hijos,
      es_fumador: json.alertas.es_fumador, 
      tiene_tarjetacredito: json.alertas.tiene_tarjetacredito, 
      tiene_cuentaahorro: json.alertas.tiene_cuentaahorro,
      tiene_seguro_hogar: json.alertas.tiene_seguro_hogar,
      tiene_plandepensiones:json.alertas.tiene_plandepensiones,
      tiene_ahorros_fuera: json.alertas.tiene_ahorros_fuera,
      tiene_seguro_coche:json.alertas.tiene_seguro_coche,
      tiene_seguro_vida: json.alertas.tiene_seguro_vida,
      ahorro_promedio: json.ahorro_promedio,
      cdp: json.cdp_prom,
      cdp_historico: json.cdp_bruto_historico,
      dias_sin_transacciones: json.dias_sin_transacciones,
      dias_profundidad_agregacion: json.dias_profundidad_agregacion,
      n_transacciones_total: json.n_transacciones_total,
      num_financiaciones: json.num_financiaciones,
      num_cuentas: json.num_cuentas_agb,
      num_bnpl: json.num_bnpl,
      num_recibos_domiciliados: json.num_recibos_domiciliados,
      desviacion_gastos_meses_naturales: json.desviacion_gastos_meses_naturales,
      desviacion_ahorro: json.desviacion_ahorro,
      comparativa_ingresos_promedio: json.comparativa_ingresos_promedio,
      fuente_principal_ingresos: json.fuentes_principales.ultimo_mes.nombre_indicador,
      cambio_tendencia_mensaje_final: json.cambios_tendencia.mensaje_final,
    }

    const desglose = {
      ingreso_trabajo: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_trabajo.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_trabajo.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_trabajo.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_trabajo.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_trabajo.promedio || 0,
        }
      },
      ingreso_pension: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_pension.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_pension.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_pension.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_pension.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_pension.promedio || 0,
        }
      },
      ingreso_facturacion: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_facturacion.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_facturacion.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_facturacion.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_facturacion.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_facturacion.promedio || 0,
        }
      },
      ingreso_ahorro: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_ahorro.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_ahorro.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_ahorro.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_ahorro.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_ahorro.promedio || 0,
        }
      },
      ingreso_financiacion: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_financiacion.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_financiacion.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_financiacion.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_financiacion.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_financiacion.promedio || 0,
        }
      },
      ingreso_impuestos: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_impuestos.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_impuestos.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_impuestos.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_impuestos.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_impuestos.promedio || 0,
        }
      },
      ingreso_anulacion: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_anulacion.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_anulacion.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_anulacion.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_anulacion.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_anulacion.promedio || 0,
        }
      },
      ingreso_gambling: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_gambling.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_gambling.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_gambling.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_gambling.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_gambling.promedio || 0,
        }
      },
      ingreso_efectivo: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_efectivo.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_efectivo.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_efectivo.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_efectivo.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_efectivo.promedio || 0,
        }
      },
      ingreso_transferencias: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_transferencias.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_transferencias.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_transferencias.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_transferencias.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_transferencias.promedio || 0,
        }
      },
      ingreso_resto: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.ingreso_otros.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.ingreso_otros.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.ingreso_otros.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.ingreso_otros.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.ingreso_otros.promedio || 0,
        }
      },
      gasto_consumo_indispensable:{
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_consumo_indispensable.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_consumo_indispensable.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_consumo_indispensable.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_consumo_indispensable.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_consumo_indispensable.promedio || 0,
        }
      },
      gasto_consumo_variado:{
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_consumo_variado.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_consumo_variado.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_consumo_variado.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_consumo_variado.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_consumo_variado.promedio || 0,
        }
      },
      gasto_alquiler: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_alquiler.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_alquiler.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_alquiler.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_alquiler.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_alquiler.promedio || 0,
        }
      },
      gasto_hogar: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_hogar.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_hogar.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_hogar.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_hogar.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_hogar.promedio || 0,
        }
      },
      gasto_trans_publico: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_trans_publico.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_trans_publico.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_trans_publico.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_trans_publico.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_trans_publico.promedio || 0,
        }
      },
      gasto_trans_privado: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_trans_privado.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_trans_privado.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_trans_privado.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_trans_privado.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_trans_privado.promedio || 0,
        }
      },
      gasto_salud: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_salud.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_salud.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_salud.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_salud.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_salud.promedio || 0,
        }
      },
      gasto_supermercado: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_supermercado.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_supermercado.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_supermercado.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_supermercado.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_supermercado.promedio || 0,
        }
      },
      gasto_colegio: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_colegio.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_colegio.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_colegio.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_colegio.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_colegio.promedio || 0,
        }
      },
      gasto_mascota: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_mascota.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_mascota.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_mascota.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_mascota.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_mascota.promedio || 0,
        }
      },
      gasto_recibos: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_recibos.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_recibos.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_recibos.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_recibos.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_recibos.promedio || 0,
        }
      },
      gasto_impuestos: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_impuestos.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_impuestos.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_impuestos.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_impuestos.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_impuestos.promedio || 0,
        }
      },
      gasto_resto_basico: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_otros_basico.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_otros_basico.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_otros_basico.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_otros_basico.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_otros_basico.promedio || 0,
        }
      },
      gasto_educacion: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_educacion.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_educacion.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_educacion.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_educacion.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_educacion.promedio || 0,
        }
      },
      gasto_restauracion: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_restauracion.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_restauracion.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_restauracion.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_restauracion.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_restauracion.promedio || 0,
        }
      },
      gasto_ocio: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_ocio.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_ocio.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_ocio.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_ocio.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_ocio.promedio || 0,
        }
      },
      gasto_suscripciones_gaming: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_suscripciones_gaming.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_suscripciones_gaming.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_suscripciones_gaming.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_suscripciones_gaming.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_suscripciones_gaming.promedio || 0,
        }
      },
      gasto_cultura: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_cultura.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_cultura.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_cultura.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_cultura.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_cultura.promedio || 0,
        }
      },
      gasto_personal: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_personal.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_personal.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_personal.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_personal.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_personal.promedio || 0,
        }
      },
      gasto_viajes: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_viajes.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_viajes.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_viajes.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_viajes.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_viajes.promedio || 0,
        }
      },
      gasto_ongs: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_ongs.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_ongs.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_ongs.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_ongs.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_ongs.promedio || 0,
        }
      },
      gasto_comercio: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_comercio.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_comercio.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_comercio.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_comercio.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_comercio.promedio || 0,
        }
      },
      gasto_tarjeta_credito: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_tarjeta_credito.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_tarjeta_credito.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_tarjeta_credito.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_tarjeta_credito.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_tarjeta_credito.promedio || 0,
        }
      },
      gasto_comisiones: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_comisiones.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_comisiones.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_comisiones.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_comisiones.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_comisiones.promedio || 0,
        }
      },
      gasto_gastos_tpv: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_gastos_tpv.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_gastos_tpv.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_gastos_tpv.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_gastos_tpv.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_gastos_tpv.promedio || 0,
        }
      },
      gasto_gambling: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_gambling.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_gambling.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_gambling.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_gambling.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_gambling.promedio || 0,
        }
      },
      gasto_resto_discrecional: {
        mes_actual: {
          monto: json.desglose_indicadores.mes_actual.gasto_otros_discrecional.suma || 0,
          porcentaje: json.desglose_indicadores.mes_actual.gasto_otros_discrecional.pct || 0,
        },
        meses_previos: {
          monto: json.desglose_indicadores.meses_previos.gasto_otros_discrecional.suma || 0,
          porcentaje: json.desglose_indicadores.meses_previos.gasto_otros_discrecional.pct || 0,
          promedio: json.desglose_indicadores.meses_previos.gasto_otros_discrecional.promedio || 0,
        }
      }
    }

    const perfil = {
      apertura: json.perfil_conductual.apertura_experiencia || 0,
      consumo_social: json.perfil_conductual.consumo_social || 0, 
      impulsivo_emocional: json.perfil_conductual.impulsivo_emocional || 0,
      planificador_control: json.perfil_conductual.planificador_control || 0
    }

    const ultimo_mes = {
      cdp_30_dias_actual: json.ultimos_dias.cdp_30_dias_actual || 0,
      cdp_30_dias_previo: json.ultimos_dias.cdp_30_dias_previo || 0,
      gasto_30_dias_actual: json.ultimos_dias.gasto_30_dias_actual || 0,
      gasto_30_dias_previo: json.ultimos_dias.gasto_30_dias_previo || 0,
      ingreso_30_dias_actual: json.ultimos_dias.ingreso_30_dias_actual || 0,
      ingreso_30_dias_previo: json.ultimos_dias.ingreso_30_dias_previo || 0
    }

    const credito = {
      score: json.perfil_crediticio.score_crediticio || 0,
      recomendacion : json.perfil_crediticio.recomendacion || '',
      allPassed: json.perfil_crediticio.toda_regla_pasada || false,
      reglas: {
          regla_desempleo: json.perfil_crediticio.reglas_de_negocio.regla_desempleo || false,
          regla_endeudamiento: json.perfil_crediticio.reglas_de_negocio.regla_endeudamiento || false,
          regla_gambling: json.perfil_crediticio.reglas_de_negocio.regla_gambling || false,
          regla_impagos: json.perfil_crediticio.reglas_de_negocio.regla_impagos || false,
          regla_ingresos: json.perfil_crediticio.reglas_de_negocio.regla_ingresos || false,
          regla_saldo_reducido: json.perfil_crediticio.reglas_de_negocio.regla_saldo_reducido || false,
      }
    }

    const resumen = {
      fecha: json.fecha,
      esValido: json.agb.valido,
      validoMessage: json.agb.message,
      categorizado,
      metodos_categorizacion,
      abono: abonoResumen,
      gasto: gastoResumen,
      saldo: saldoResumen,
      alertas: alertasResumen,
      perfil,
      ultimo_mes,
      desglose,
      credito,
    }

    return resumen;
}

export function createFinancialFile() {
  const rawData = localStorage.getItem('financeData');
  if (!rawData) return null;
  const json = JSON.parse(rawData).json;

  const exportData = json.resultado_agb_export;
  if (!exportData) return null;

  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth()+1).toString().padStart(2, '0')}/${today.getFullYear()}`;

  const newDoc = [
    { Header: 'Fecha', Value: formattedDate, Description: 'Fecha análisis' },
    { Header: 'Check_AgB', Value: exportData.check_agb === true ? 'OK' : 'KO', Description: 'Validación Agb' },
    { Header: 'N_dias agregados', Value: (exportData.n_dias_agregados || 0), Description: 'Días de profundidad' },
    { Header: 'N_movimientos', Value: (exportData.n_movimientos || 0), Description: 'Número de movimientos' },
    { Header: 'D_sin_mov', Value: (exportData.dias_sin_transacciones || 0), Description: 'Días sin movimientos' },
    { Header: 'N_cuentas', Value: (exportData.num_cuentas_agb || 0), Description: 'Número de cuentas' },
    { Header: 'Prom_ING_mes', Value: (exportData.prom_ingresos_mensual || 0), Description: 'Promedio mensual de ingresos' },
    { Header: 'Estab_ING', Value: (exportData.estabilidad_ingresos * 100 || 0), Description: 'Ingresos duros/Ingresos totales' },
    { Header: 'Prom_GAST_mes', Value: (exportData.prom_gastos_mensual || 0), Description: 'Promedio mensual de gastos' },
    { Header: 'Estab_GAST', Value: (exportData.estabilidad_gastos * 100 || 0), Description: 'Gastos básicos/Gastos totales' },
    { Header: 'Prom_CdP_mes', Value: (exportData.prom_cdp_mensual || 0), Description: 'Promedio mensual CdP' },
    { Header: 'SALD_actual', Value: (exportData.saldo_disponible_actual || 0), Description: 'Saldo foto final' },
    { Header: 'SALD_prom', Value: (exportData.saldo_promedio || 0), Description: 'Saldo promedio min diario' },
    { Header: 'SALD_max', Value: (exportData.saldo_maximo || 0), Description: 'Saldo máx últ 6m' },
    { Header: 'SALD_min', Value: (exportData.saldo_minimo || 0), Description: 'Saldo min últ 6m' },
    { Header: 'Regimen_contrato', Value: exportData.regimen_contrato || 'NA', Description: 'Categoría regimen de contrato' },
    { Header: 'Fuente_ingresos', Value: exportData.fuente_ingresos || 'NA', Description: 'Categoría fuente ppal de ingresos' },

    { Header: 'ING_Trabajo', Value: (exportData.prom_ingresos_trabajo_mensual || 0), Description: 'Ingresos mensuales por trabajo' },
    { Header: 'ING_Pens', Value: (exportData.prom_ingresos_pensiones_mensual || 0), Description: 'Ingresos mensuales por pensión' },
    { Header: 'ING_Subs', Value: (exportData.prom_ingresos_subsidio_mensual || 0), Description: 'Ingresos mensuales por subsidio' },
    { Header: 'ING_Ahorro', Value: (exportData.prom_ingresos_ahorro_mensual || 0), Description: 'Ingresos mensuales por ahorro' },
    { Header: 'ING_Fact', Value: (exportData.prom_ingresos_facturacion_mensual || 0), Description: 'Ingresos mensuales por facturación' },
    { Header: 'ING_Efec', Value: (exportData.prom_ingresos_efectivo_mensual || 0), Description: 'Ingresos mensuales por efectivo' },
    { Header: 'ING_Transf', Value: (exportData.prom_ingresos_transferencia_mensual || 0), Description: 'Ingresos mensuales por transferencia' },
    { Header: 'ING_Trasp', Value: (exportData.prom_ingresos_traspaso_mensual || 0), Description: 'Ingresos mensuales por traspaso' },
    { Header: 'ING_Devol', Value: (exportData.prom_ingresos_devoluciones_mensual || 0), Description: 'Ingresos mensuales por devolución' },
    { Header: 'ING_Anul', Value: (exportData.prom_ingresos_anulaciones_mensual || 0), Description: 'Ingresos mensuales por anulación' },
    { Header: 'ING_Gamb', Value: (exportData.prom_ingresos_gambling_mensual || 0), Description: 'Ingresos mensuales por gambling' },
    { Header: 'ING_Otros', Value: (exportData.prom_ingresos_otros_mensual || 0), Description: 'Ingresos mensuales por otros' },
    { Header: 'ING_Finan', Value: (exportData.prom_ingresos_financiacion_mensual || 0), Description: 'Ingresos mensuales por financiación' },
    { Header: 'ING_Imp', Value: (exportData.prom_ingresos_impuestos_mensual || 0), Description: 'Ingresos mensuales por impuestos' },

    { Header: 'GAST_Basico_vs_total', Value: (exportData.porc_gasto_basico_vs_total || 0), Description: 'Porcentaje gasto básico sobre total gasto' },
    { Header: 'GAST_Discr_vs_total', Value: (exportData.porc_gasto_discrecional_vs_total || 0), Description: 'Porcentaje gasto discrecional sobre total gasto' },
    { Header: 'GAST_Resto_vs_total', Value: (exportData.porc_gasto_resto_vs_total || 0), Description: 'Porcentaje gasto resto sobre total gasto' },

    { Header: 'GAST_Consumo_Indis', Value: (exportData.prom_gasto_indispensable_mensual || 0), Description: 'Gastos mensuales por consumo indispensable' },
    { Header: 'GAST_Recibos', Value: (exportData.prom_gasto_recibos_mensual || 0), Description: 'Gastos mensuales por recibos' },
    { Header: 'GAST_Comis', Value: (exportData.prom_gasto_comisiones_mensual || 0), Description: 'Gastos mensuales por comisiones' },
    { Header: 'GAST_Imp', Value: (exportData.prom_gasto_impuestos_mensual || 0), Description: 'Gastos mensuales por impuestos' },
    { Header: 'GAST_Efectivo', Value: (exportData.prom_gasto_efectivo_mensual || 0), Description: 'Gastos mensuales por efectivo' },
    { Header: 'GAST_Transf', Value: (exportData.prom_gasto_transferencia_mensual || 0), Description: 'Gastos mensuales por transferencia' },
    { Header: 'GAST_Trasp', Value: (exportData.prom_gasto_traspaso_mensual || 0), Description: 'Gastos mensuales por traspaso' },
    { Header: 'GAST_Consumo_Var', Value: (exportData.prom_gasto_variado_mensual || 0), Description: 'Gastos mensuales por consumo variado' },
    { Header: 'GAST_Tarj', Value: (exportData.prom_gasto_tarjeta_credito_mensual || 0), Description: 'Gastos mensuales por tarjeta de crédito' },
    { Header: 'GAST_TPV', Value: (exportData.prom_gasto_tpv_mensual || 0), Description: 'Gastos mensuales por TPV' },
    { Header: 'GAST_Gambling', Value: (exportData.prom_gasto_gambling_mensual || 0), Description: 'Gastos mensuales por gambling' },
    { Header: 'GAST_Otros', Value: (exportData.prom_gasto_otros_mensual || 0), Description: 'Gastos mensuales por otros' },
    { Header: 'GAST_Financiacion', Value: (exportData.prom_gasto_financiacion_mensual || 0), Description: 'Gastos mensuales por financiación' },
    { Header: 'GAST_Recobro', Value: (exportData.prom_gasto_recobros_mensual || 0), Description: 'Gastos mensuales por recobros' },
    { Header: 'GAST_Embargo', Value: (exportData.prom_gasto_embargo_mensual || 0), Description: 'Gastos mensuales por embargo' },
    
    { Header: 'ALERT_Descubierto', Value: exportData.alerta_descubierto === true ? 'Sí' : 'No', Description: 'Alerta descubierto últ. 6m' },
    { Header: 'ALERT_Embargo', Value: exportData.alerta_embargo === true ? 'Sí' : 'No', Description: 'Alerta embargos últ. 6m' },
    { Header: 'ALERT_Recobro', Value: exportData.alerta_recobro === true ? 'Sí' : 'No', Description: 'Alerta recobros últ. 6m' },
    { Header: 'ALERT_Recib_dev', Value: exportData.alerta_recib_dev === true ? 'Sí' : 'No', Description: 'Alerta recibos devueltos últ. 6m' },
    { Header: 'ALERT_Multas', Value: exportData.alerta_multas === true ? 'Sí' : 'No', Description: 'Alerta multas últ. 6m' },
    { Header: 'ALERT_Microprest', Value: exportData.alerta_microprestamo === true ? 'Sí' : 'No', Description: 'Alerta micropréstamos últ. 6m' },
    { Header: 'ALERT_Gambling', Value: exportData.alerta_gambling === true ? 'Sí' : 'No', Description: 'Alerta gambling últ. 6m' },
    // { Header: 'ALERT_Finan', Value: exportData.alerta_financiacion === true ? 'Sí' : 'No', Description: 'Alerta financiación últ. 6m' },
    { Header: 'ALERT_Edeud', Value: exportData.alerta_alto_endeudamiento === true ? 'Sí' : 'No', Description: 'Alerta alto endeudamiento últ. 6m' },

    { Header: 'SCORE_APERTURA_EXP', Value: (exportData.score_apertura_exp || 0), Description: 'Puntuación de apertura - experiencia' },
    { Header: 'SCORE_PLANI_CONTROL', Value: (exportData.score_planif_control || 0), Description: 'Puntuación de planificación - control' },
    { Header: 'SCORE_CONS_SOCIAL', Value: (exportData.score_cons_social || 0), Description: 'Puntuación de consumo social' },
    { Header: 'SCORE_IMPUL_EMOC', Value: (exportData.score_impulsivo_emocional || 0), Description: 'Puntuación de impulso emocional' },
    
    { Header: 'CREDITO_SCORE', Value: (exportData.score_crediticio || 0), Description: 'Puntuación crediticia del modelo proforma' },
    { Header: 'REGLAS_DE_NEGOCIO', Value: (exportData.reglas_de_negocio === true ? 'OK' : 'KO'), Description: 'Cumplimiento de las reglas de negocio' },
    { Header: 'RECOMENDACIÓN', Value: (exportData.recomendacion || 0), Description: 'Acción recomendada según datos crediticios' },
  ];

  const EURO_FMT_ES = '[$-es-ES] #,##0.00 "€"';
  const PERCENT_FMT_ES = '0.00%';
  const NUMBER_FMT_ES = '#,##0';

  // Helper: decidir formato según Header o Description
  const getExcelCell = (item) => {
    if (typeof item.Value !== 'number') {
      // No es número → lo dejamos como string directo
      return item.Value;
    }

    // Detectar según Header o Description
    if (item.Header.startsWith('Estab_') || item.Header.includes('vs') || item.Header.startsWith('SCORE') || item.Header.startsWith('ING_') && item.Header.includes('%')) {
      // Porcentaje (ej: Estabilidad, Porcentaje gasto, Scores)
      return { v: item.Value / 100, t: "n", z: PERCENT_FMT_ES };
    }

    if (
      item.Header.startsWith('Prom_') ||
      item.Header.startsWith('SALD_') ||
      item.Header.startsWith('ING_') ||
      item.Header.startsWith('GAST_')
    ) {
      // Moneda (valores en euros)
      return { v: item.Value, t: "n", z: EURO_FMT_ES };
    }

    if (
      item.Header.startsWith('N_') ||
      item.Header.startsWith('D_') ||
      item.Header.startsWith('CREDITO')
    ) {
      // Números (conteos, días, etc.)
      return { v: item.Value, t: "n", z: NUMBER_FMT_ES };
    }

    // Por defecto → moneda
    return { v: item.Value, t: "n", z: EURO_FMT_ES };
  };

  const headers = newDoc.map(item => item.Header);
  const values = newDoc.map(item => getExcelCell(item));
  const descriptions = newDoc.map(item => item.Description);

  const worksheetData = [
    headers,
    values,
    descriptions
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  const colWidth = 13;
  worksheet['!cols'] = Array(61).fill({ wch: colWidth });
  XLSX.utils.book_append_sheet(workbook, worksheet, 'AGB Export');

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  return new Blob([wbout], { type: 'application/octet-stream' });
}

export default function Upload({
  disabled,
  multiple = false,
  error,
  helperText,
  //
  file,
  onDelete,
  //
  files,
  thumbnail,
  onUpload,
  onRemove,
  onRemoveAll,
  sx,
  ...other
}) {
  const themes = useTheme();

  const { getRootProps, getInputProps, isDragActive, isDragReject, fileRejections } = useDropzone({
    multiple,
    disabled,
    ...other,
  });

  const hasFile = !!file && !multiple;

  const hasFiles = !!files && multiple && !!files.length;

  const hasError = isDragReject || !!error;

  const renderPlaceholder = (
    <Stack spacing={3} alignItems="center" justifyContent="center" flexWrap="wrap">
      <UploadIllustration sx={{ width: 1, maxWidth: 200 }} />
      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Typography variant="h6">Arrastra o selecciona directamente un transaccional</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Arrastra el transaccional a esta caja o pincha en el
          <Box
            component="span"
            sx={{
              mx: 0.5,
              color: 'primary.main',
              textDecoration: 'underline',
            }}
          >
            enlace
          </Box>
          para buscarlo desde su dispositivo
        </Typography>
      </Stack>
    </Stack>
  );

  const renderSinglePreview = (
    <SingleFilePreview imgUrl={typeof file === 'string' ? file : file?.preview} />
  );

  const removeSinglePreview = hasFile && onDelete && (
    <IconButton
      size="small"
      onClick={onDelete}
      sx={{
        top: 16,
        right: 16,
        zIndex: 9,
        position: 'absolute',
        color: (theme) => alpha(theme.palette.common.white, 0.8),
        bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
        '&:hover': {
          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.48),
        },
      }}
    >
      <Iconify icon="mingcute:close-line" width={18} />
    </IconButton>
  );

  const renderMultiPreview = hasFiles && (
    <>
      <Box sx={{ my: 3 }}>
        <MultiFilePreview files={files} thumbnail={thumbnail} onRemove={onRemove} />
      </Box>

      <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
        {onRemoveAll && (
          <Button color="inherit" variant="outlined" size="small" onClick={onRemoveAll}>
            Remove All
          </Button>
        )}

        {onUpload && (
          <Button
            size="small"
            variant="contained"
            onClick={onUpload}
            startIcon={<Iconify icon="eva:cloud-upload-fill" />}
          >
            Upload
          </Button>
        )}
      </Stack>
    </>
  );

  const fileInfoText = 
  `**Requerimientos del fichero de entrada**

  El archivo excel o csv debe contener las siguientes columnas bien en este orden o nombradas de la siguiente manera:
  * **Scrape_date**: Fecha de consulta de la agregación y base del análisis
  * **Account_id**: Referencia de la cuenta asociada a dicho movimiento
  * **Transaction_id**: Identificativo único del movimiento en formato numérico
  * **Concepts**: Descripción del movimiento
  * **Amount**: Cantidad asociada al movimiento
  * **Balance**: Resultado del balance tras acometer el movimiento
  * **Value_date**: Fecha del movimiento
  
  _*Las fechas siguen un formato de fecha corta_`

  return (
    <Box sx={{ width: 1, position: 'relative', ...sx }}>
      <Box
        {...getRootProps()}
        sx={{
          p: 5,
          outline: 'none',
          borderRadius: 1,
          cursor: 'pointer',
          overflow: 'hidden',
          position: 'relative',
          bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
          border: (theme) => `1px dashed ${alpha(theme.palette.grey[500], 0.2)}`,
          transition: (theme) => theme.transitions.create(['opacity', 'padding']),
          '&:hover': {
            opacity: 0.72,
          },
          ...(isDragActive && {
            opacity: 0.72,
          }),
          ...(disabled && {
            opacity: 0.48,
            pointerEvents: 'none',
          }),
          ...(hasError && {
            color: 'error.main',
            borderColor: 'error.main',
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
          }),
          // ...(hasFile && {
          //   padding: '24% 0',
          // }),
        }}
      >
        <input {...getInputProps()} />

        {renderPlaceholder}

        <ClickableTooltip title={<ReactMarkdown>{fileInfoText}</ReactMarkdown>} arrow>
          <IconButton component="span" sx={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              color: themes.palette.grey[600],
            }}>
                <Iconify icon="mdi:information-outline" width={20} height={20} color={themes.palette.text.secondary} />
            </IconButton>
        </ClickableTooltip>
      </Box>

      {/* {removeSinglePreview} */}

      {helperText && helperText}

      <RejectionFiles fileRejections={fileRejections} />

      {renderMultiPreview}
    </Box>
  );
}

Upload.propTypes = {
  disabled: PropTypes.object,
  error: PropTypes.bool,
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  files: PropTypes.array,
  helperText: PropTypes.object,
  multiple: PropTypes.bool,
  onDelete: PropTypes.func,
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
  onUpload: PropTypes.func,
  sx: PropTypes.object,
  thumbnail: PropTypes.bool,
};
